export const NAMESPACE = 'flatJobs';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const CLEAR_RDC_OFFSET = `${NAMESPACE}/CLEAR_RDC_OFFSET`;
export const DECREASE_RDC_OFFSET = `${NAMESPACE}/DECREASE_RDC_OFFSET`;
export const INCREASE_RDC_OFFSET = `${NAMESPACE}/INCREASE_RDC_OFFSET`;
export const SET_CLOUD_TYPE = `${NAMESPACE}/SET_CLOUD_TYPE`;
